module.exports = __webpack_public_path__ + "assets/img/mecha-btn-ff5e8f0a.png";